import React, { CSSProperties, FC } from 'react';
import { useTheme } from '../../../../hooks/useTheme';

export const EddDash: FC = () => {
  const { headersMediumNone } = useTheme();

  const dashTheme: CSSProperties = {
    ...headersMediumNone,
    lineHeight: headersMediumNone?.lineHeight ?? '1.25rem',
    width: '1rem',
    textAlign: 'center',
    fontSize: '1rem',
    margin: 0,
  };

  return <div style={dashTheme}>-</div>;
};

export default EddDash;
